import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../../../../Utils/Auth.js";
import FullScreenLoader from "../../../../Component/FullScreenLoader.jsx";
import { customErrorHandler, toTitleCase } from "../../../../Utils/helper.js";
import AddWithdraw from "../../../../Component/deposit_Withdraw_Dialog/index";
import Website_Service from "../../../../Services/apiService/website-service.js";

const WithdrawWebsiteBalance = ({
  state,
  renderParent,
  setPage,
  handleClose,
}) => {
  const auth = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const initialFormData = {
    amount: 0,
    remarks: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const handelsubmit = () => {
    if (
      formData.amount === 0 ||
      formData.remarks === "" ||
      formData.amount < 0
    ) {
      if (formData.amount < 0) {
        toast.error(toTitleCase("Amount can not be negetive"));
        return;
      }
      toast.error(toTitleCase("Amount and Remarks fields cannot be empty."));
      return;
    }
    setIsLoading(true);
    const data = {
      amount: Number(formData.amount),
      transactionType: "Manual-Website-Withdraw",
      remarks: formData.remarks,
    };
    Website_Service
      .manualWebsiteWithdraw(state.data, data, auth.user)
      .then((res) => {
        setIsLoading(false);
        if (res) {
          toast.success(toTitleCase(res.data.message || "Success"));
          // const getbankNameUpdated = JSON.parse(JSON.stringify(getbankName))
          // getbankNameUpdated.forEach(bank => {
          //   if (bank.bankId === ID) {
          //     bank.balance = bank.balance - res.data.data.withdrawAmount
          //   }
          // })
          // setGetBankName(getbankNameUpdated)
          // setPage(1); // beacuse now user can find the same in first page only (commented beacuse business logic changed)
          renderParent(res.data);
          handleDialogClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(customErrorHandler(error));
      });
  };

  const handleDialogClose = () => {
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <React.Fragment>
      <AddWithdraw
        title={"Website Withdraw"}
        formData={formData}
        setFormData={setFormData}
        isLoading={isLoading}
        handelSubmit={handelsubmit}
        userName={auth.user.userName}
        dilaogShow={state.show}
        handleClose={handleDialogClose}
      />
    </React.Fragment>
  );
};

export default React.memo(WithdrawWebsiteBalance);
